import { render, staticRenderFns } from "./MenuBoxLinearCopy.vue?vue&type=template&id=59b5c39f&"
import script from "./MenuBoxLinearCopy.vue?vue&type=script&lang=js&"
export * from "./MenuBoxLinearCopy.vue?vue&type=script&lang=js&"
import style0 from "./MenuBoxLinearCopy.vue?vue&type=style&index=0&id=59b5c39f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports